import {createAction, props} from "@ngrx/store";
import {AccountAchievement} from "../../models/AccountAchievement";


export const UPDATE = '[AccountAchievement] Update';
export const REFRESH = '[AccountAchievement] Init';
export const update = createAction(UPDATE, props<{ accountAchievement: AccountAchievement[] }>());
export const refresh = createAction(REFRESH);
